// src/modules/operaciones/inventarios/hooks/useNegativos.js
import { useState, useEffect, useCallback, useRef } from "react";
import { API_URL, POLL_MS, POLL_MAX_MS, pedirJson } from "../utils/negativosComun";

export default function useNegativos() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [calculando, setCalculando] = useState(false);
  const [error, setError] = useState(null);

  const pollStartRef = useRef(null);

  const cargar = useCallback(async (signal) => {
    try {
      // Se llama al nuevo endpoint de la Fase 1
      const data = await pedirJson(`${API_URL}/negativos/lista?limite=1000&estado=todos`, signal);
      
      // El backend devuelve los datos ya listos en 'data'
      setItems(Array.isArray(data.data) ? data.data : []);
      setCalculando(Boolean(data.meta?.calculando));
      setError(null);
      
      return { listo: !data.meta?.calculando };
    } catch (e) {
      if (e.name !== "AbortError") setError(e.message);
      return { listo: true, error: true };
    }
  }, []);

  useEffect(() => {
    const ctrl = new AbortController();
    let timer;

    const ciclo = async () => {
      if (ctrl.signal.aborted) return;
      if (!pollStartRef.current) pollStartRef.current = Date.now();
      setLoading(true);

      const r = await cargar(ctrl.signal);
      if (ctrl.signal.aborted) return;

      if (r.error) {
        setLoading(false);
        return;
      }
      setLoading(!r.listo);

      if (!r.listo) {
        const elapsed = Date.now() - pollStartRef.current;
        if (elapsed < POLL_MAX_MS) {
          timer = setTimeout(ciclo, POLL_MS);
          return;
        }
        setError("El cálculo está tardando más de lo esperado.");
      }
      setLoading(false);
    };

    ciclo();
    return () => {
      ctrl.abort();
      if (timer) clearTimeout(timer);
    };
  }, [cargar]);

  return { items, loading, calculando, error };
}